export default __webpack_public_path__ + "static/background_circle_corner-2c68f8e06af17112aeb4aca50834779c.png";